/* eslint-disable no-console */
const logger = {
  warn(...params) {
    console.warn('[Occupancy Map Component]:', ...params)
  },

  log(...params) {
    console.log('[Occupancy Map Component]:', ...params)
  },

  error(...params) {
    console.error('[Occupancy Map Component]:', ...params)
  },

  deprecate(deprecated, alternative) {
    console.warn(
      `[Occupancy Map Component]: ${deprecated} has been deprecated, use ${alternative} instead.`
    )
  },
}

export default logger
